export default {"src":"/intl/_next/static/media/orange_money.a81f7045.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};